
  // The last page takes the "Load more" button away, and focus with it. Focus then goes to the
  // first row that page added, so a keyboard user reads on from where the list grew. A list read
  // again instead (a filter changed) holds a page at most, so it has no row at that index.
  export default {
    mounted() {
      this.listed = null
      this.el.addEventListener("click", () => {
        this.listed = document.querySelectorAll(`#${this.el.dataset.list} > li`).length
      })
    },
    destroyed() {
      const listId = this.el.dataset.list
      const index = this.listed
      if (index === null) return

      requestAnimationFrame(() => {
        if (document.activeElement && document.activeElement !== document.body) return
        document.querySelectorAll(`#${listId} > li`)[index]?.querySelector("a")?.focus()
      })
    }
  }
